export default class {
  toLogin () {
    if (!localStorage.sessionId&&!window.localStorage.isLoginDangerOus) {
      window.location.replace(window.location.href.split('/#/')[0] + '/login.html')
    }else if(localStorage.sessionId&&!window.localStorage.isLoginDangerOus){
      window.location.replace(window.location.href.split('/#/')[0] + '/login.html')
    }else{
      this.$router.push({
        path: '/station'
      })
    }
  }
  toPage(name){
    let params={}
    this.$router.push({name:name,params:params})
  }
  removeWellCome () {
    $('#wellcome').remove() // 清除等待提示
  }
  checkPageSize () {
    // 计算网页可视区域大小、分辨率，告知用户如何得到最佳体验
    // 应该支持 1440*900
    if (document.documentElement.clientWidth < 1440 || document.documentElement.clientHeight < 820) {
      this.$alert(`您当前网页的可视区域为${document.documentElement.clientWidth}×${document.documentElement.clientHeight}，为了更好地使用系统，请最大化浏览器窗口或使用更大分辨率的屏幕（推荐分辨率1920×1080）。`, '温馨提示', {
        confirmButtonText: '确定'
      })
    }
  }

  logOut(){
    window.localStorage.removeItem('sessionId');
    window.localStorage.removeItem('isLoginDangerOus');
    window.location.replace(window.location.href.split('/#/')[0] + '/login.html');
  }
}
